import React, { useEffect, useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuthDispatch, useAuthState } from '../../Helper/Context/contex';
import { loginUser, logout } from '../../Helper/Context/actions';
import './Login.css'

export default function Login() {

    const navigate = useNavigate();
    const dispatch = useAuthDispatch()
    const userDetails = useAuthState()
    const { RoleID, UserID } = userDetails.user

    const [userName, setuserName] = useState("")
    const [password, setpassword] = useState("")
    const [Validationerror, setValidationerror] = useState("")
    const [loading, setloading] = useState(false)

    React.useEffect(() => {
        logout(dispatch)
    }, [])

    const handleLogin = async (e) => {
        e.preventDefault()
        if (userName !== '' && password !== '') {
            try {
                let response = await loginUser(dispatch, { userName, password, setloading, handleRollIdWiseDashboard });
                if (!response) return;
                // navigate('/dashboard');

            } catch (error) {
                console.log(error);
            }
            setValidationerror("")
        } else {
            setValidationerror("Error")
        }

    }

    const handleRollIdWiseDashboard = (data) => {
        if (data.M_ProjectTypeID == '0') {
            if (data?.RoleID == 3 || data?.RoleID == 2 || data?.RoleID == 58 || data?.RoleID == 59 || data?.RoleID == 24 || data?.RoleID == 54) {
                navigate('/garden?ProjectTypeId=5&DashboardName=Garden'); // New Dashboard
            } else {
                navigate('/gardenn?ProjectTypeId=5&DashboardName=Garden'); // OLD Dashboard
            }
        } else if (data.M_ProjectTypeID == '1') {
            if (data?.RoleID == '48') {
                navigate('/watersupply?name=Water%20Supply&ProjectTypeId=1&DashboardName=Water%20Supply');
            } else {
                navigate('/watersupply?ProjectTypeId=1&DashboardName=Water');
            }
        } else if (data.M_ProjectTypeID == '6') {
            navigate('/watersupply?ProjectTypeId=6&DashboardName=Water');
        }
        else if (data.M_ProjectTypeID == '9') {
            if (data?.RoleID == '68') {
                navigate('/watersupply?ProjectTypeId=9&DashboardName=Water');
            }
        }
        else if ((data.M_ProjectTypeID == '3' && (data.RoleID == '28' || data.RoleID == '32' || data.RoleID == '37')) || data.M_ProjectTypeID == '7') {
            navigate('/watersupply?ProjectTypeId=7&DashboardName=Water');
        } else if (data.M_ProjectTypeID == '2') {
            if (data?.RoleID == '47' || data?.RoleID == '51') {
                navigate('/sewerage?name=Sewerage&ProjectTypeId=2&DashboardName=Sewerage');
            }
        } else if (data.M_ProjectTypeID == '3' && (data.RoleID == '20' || data.RoleID == '49' || data.RoleID == '52')) {
            if (data?.RoleID == '20') {
                navigate('/stpdashboard?ProjectTypeId=3&DashboardName=STP');
            }
            if (data?.RoleID == '49' || data.RoleID == '52') {
                navigate('/stpdashboard?name=STP&ProjectTypeId=3&DashboardName=STP');
            }
        } else if (data.M_ProjectTypeID == '4') {
            if (data?.RoleID == '53') {
                navigate('/dashboard?name=Road%20Work&ProjectTypeId=4&DashboardName=Road');
            } else {
                navigate('/dashboard?ProjectTypeId=4&DashboardName=Road');
            }
        } else if (data.M_ProjectTypeID == '5') {
            if (data?.RoleID == '9' || data?.RoleID == '6') {
                navigate('/gardenn?ProjectTypeId=5&DashboardName=Garden'); // OLD Dashboard
            } else if (data?.RoleID == '51') {
                navigate('/gardenn?name=Garden&ProjectTypeId=5&DashboardName=Garden')
            } else {
                navigate('/garden?ProjectTypeId=5&DashboardName=Garden');  // New Dashboard
            }
        } else if (data.M_ProjectTypeID == '8') {
            if (data?.RoleID == '43' || data?.RoleID == '52' || data?.RoleID == '57') {
                navigate('/ElectricalDashboard?name=Electrical&ProjectTypeId=8&DashboardName=Electrical'); // OLD Dashboard
            }
            if (data?.RoleID == '44') {
                navigate(`/DailyElEdataFetch?ProjectTypeId=8&DashboardName=Electrical`)
            }
            if (data?.RoleID == '45' || data?.RoleID == '46') {
                navigate(`/PillerWiseBenchMark?ProjectTypeId=8&DashboardName=Electrical`)
            }
        }
    }

    const showPass = () => {
        var x = document.getElementById("pass");
        var y = document.getElementById("eye");
        if (x.type === "password") {
            x.type = "text";
        } else {
            x.type = "password";
        }
        if (y.className === "fa fa-eye") {
            y.className = "fa fa-eye-slash";
        } else {
            y.className = "fa fa-eye";
        }
    }

    return (
        <>
            {/* <div className="bjp_background">
            <div className='container-fluid road_login_bg'>
                <div className="form_card row col-lg-6 col-md-7 m-auto">
                    <div className="col-12 py-5 login_body ">
                        <div className="rounded rounded-3 shadow">
                           
                            <p class="text-center mt-2"><img src='../assets/img/nmmc_logo.png' alt="" className="nmmc_logo_border shadow " /></p>
                            <div className='login-heading text-white'>
                                <p style={{ fontSize: '25px', textAlign: 'center' }}>Login</p>
                            </div>
                            <form className="garden_login">
                                <label for="exampleInputPassword1" className="form-label text-white ">Username</label>
                                <div className="input-group mb-2">
                                    <input type="text"
                                        className={`form-control ${Validationerror === "" ? "login_input" : "login_input_error"}`}
                                        placeholder="Username"
                                        id="username"
                                        autoComplete="off"
                                        value={userName}
                                        onChange={(e) => setuserName(e.target.value)}
                                    />
                                    
                                    <span className="input-group-text" id="basic-addon2"><i className="fa-regular fa-user blue_color"></i></span>
                                </div>
                                <label for="exampleInputPassword1" className="form-label text-white">Password</label>
                                <div className="input-group mb-3">
                                    <input
                                    
                                        name="logpass"
                                        type="password"
                                        className={`form-control ${Validationerror === "" ? "login_input" : "login_input_error"}`}
                                        placeholder="Password"
                                        id="pass"
                                        autoComplete="new-password"
                                        value={password}
                                        onChange={(e) => setpassword(e.target.value)}

                                    />
                                 
                                    <span className="input-group-text" id="basic-addon2">
                                     
                                        <span id='eye' className="fa fa-eye-slash"
                                            onClick={() => showPass()}

                                        ></span>
                                    </span>
                                </div>
                                <p className="float-end text-white"> Forgot Password</p><br />

                                <div className="pt-3">
                                    <button className="login_buttton green text-center py-2 text-white rounded-3 fw-bolder"
                                        onClick={handleLogin}
                                        disabled={loading}
                                    >
                                        {loading && (
                                            <i
                                                className="fa fa-spinner fa-spin"
                                                style={{ marginRight: "5px" }}
                                            />
                                        )}
                                        
                                        {!loading && <span>Login</span>}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div> */}

            <div className='g-0' style={{ height: '100vh' }}>

                {/* start moile nav */}


                <div className="row d-flex shadow  nmmc_blue_bg align-items-center pc_none  " style={{ height: '12vh' }} >
                    <div className='col-12 text-start ps-4'>
                        <span className="headingcolor  font-weight-bold text-white" style={{ fontFamily: "poppins", alignSelf: "center", fontSize: '18px' }}>
                            Navi Mumbai Municipal Corporation</span>
                        {/* <br /> */}
                        <span className="text-color-change  text-white ps-2" style={{ fontFamily: "poppins", alignSelf: "center", fontSize: '12px' }}>
                            वेब व मोबाईल आधारित </span>
                    </div>
                </div>

                {/* end moile nav */}


                {/* start pc nav */}
                <div className=" row d-flex shadow  nmmc_blue_bg align-items-center mx-auto   mobile_none " style={{ height: '12vh' }} >

                    <div className="col-2 col-md-1 mobile_none">
                        <div className="">
                            <img src="../assets/img/nmmc_large_logo2.png" alt="" srcset="" className=" header_img float-right" />
                        </div>
                    </div>

                    <div className="col-8 col-md-11 px-3 align-items-center justify-content-center " style={{ textAlign: "start" }}>

                        <span className="headingcolor  font-weight-bold text-white" style={{ fontFamily: "poppins", alignSelf: "center", fontSize: '23px' }}>
                            Navi Mumbai Municipal Corporation </span>
                        {/* <br /> */}
                        <span className="text-color-change  text-white ps-1" style={{ fontFamily: "poppins", alignSelf: "center", fontSize: '15px' }}>
                            Comprehensive Contract Work Dashboard </span>

                    </div>
                </div>
                {/* end pc nav */}



                <div className='row px-2' style={{ height: '78vh' }}>

                    <div className="col-12 col-md-7 col-lg-8 px-5 bjp_background mx-auto  ">
                    </div>

                    <div className="col-12 col-md-5 mt-1 mt-md-0 col-lg-4 shadow mx-auto  bg-white " style={{ display: 'flex', justifyContent: "center", alignItems: "center" }}>
                        <div className='row g-0' >


                            <div className="text-center">
                                <p className=""> <img src="../assets/img/nmmc_large_logo2.png" alt="" srcset=""
                                    className="logo_in_circle" /></p>

                                <h4 className="text- pb-2 pb-md-0 pb-lg-0 font-weight-bold" style={{ fontFamily: "Poppins, sans-serif" }}>NMMC DAKSHA</h4>
                            </div>
                            <div className='col-9 mx-auto'>



                                <form className=" mt-2" style={{ width: '100%' }}>
                                    {/* <label for="exampleInputPassword1" className="form-label text-dark">Username</label> */}
                                    <div className="input-group mb-3">
                                        <input type="text"
                                            className={`form-control ${Validationerror === "" ? "login_input" : "login_input_error"}`}
                                            placeholder="Username"
                                            id="username"

                                            autoComplete="off"
                                            value={userName}
                                            onChange={(e) => setuserName(e.target.value)}
                                        // style={{width:"40em"}}
                                        />

                                        <span className="input-group-text" id="basic-addon2"><i className="fa-regular fa-user blue_color"></i></span>
                                    </div>
                                    {/* <label for="exampleInputPassword1" className="form-label text-dark">Password</label> */}
                                    <div className="input-group mb-2">
                                        <input

                                            name="logpass"
                                            type="password"
                                            className={`form-control ${Validationerror === "" ? "login_input" : "login_input_error"}`}
                                            placeholder="Password"
                                            id="pass"
                                            autoComplete="new-password"
                                            value={password}
                                            onChange={(e) => setpassword(e.target.value)}

                                        />

                                        <span className="input-group-text" id="basic-addon2">

                                            <span id='eye' className="fa fa-eye-slash"
                                                style={{ fontSize: "11px" }}
                                                onClick={() => showPass()}

                                            ></span>
                                        </span>
                                    </div>
                                    {/* <p className="float-end text-dark"><b>Forgot Password</b></p><br /> */}

                                    <div className="pt-2">
                                        <button className="login_buttton bg_but text-center py-2 text-white rounded-3 fw-bolder"
                                            onClick={handleLogin}
                                            disabled={loading}
                                            id='login_buttton1'
                                        >
                                            {loading && (
                                                <i
                                                    className="fa fa-spinner fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />
                                            )}

                                            {!loading && <span>Login</span>}
                                        </button>
                                    </div>
                                </form>
                            </div>


                            <div className="col-12 text-center pt-3 pb-1  pt-lg-2" style={{ alignSelf: 'center' }}>

                                <div className='mb-1'>
                                    <h5 className='text-dark fw-bold'> <i className="fa-solid fa-circle-info "></i> Help Desk</h5>
                                </div>

                                <div className="">
                                    <h6 className='text-danger font-weight-bold'>Customer Support</h6>
                                </div>

                                <div className='pt-1 '>
                                    <h6 className="text-dark"><i className="fa-solid fa-phone  pe-1"></i>
                                        {/* Contact No:  */}
                                        <a
                                            href="tel:91726 50917" /><span className="text-dark ml-2">  +91 91726 50917</span> </h6>
                                </div>

                                <div className='pt-1'>
                                    <h6 className="text-dark pb-2"><i className="fa-solid fa-envelope  pe-1"></i>
                                        {/* Email ID: */}
                                        <a
                                            href="mailto:info@cdat.co.in" /><span className="text-dark ml-2">  info@cdat.co.in</span> </h6>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>

                <div className='row'>
                    <div className='col-12 px-3 px-lg-0 text-center  mt-3 mt-md-0 d-flex align-items-center justify-content-center  nmmc_blue_bg' style={{ height: '12vh' }}>
                        <span className="text-white text-center " style={{ fontFamily: 'Poppins, sans-serif' }}>
                            &copy;

                            <span className="silver text-white  ">{new Date().getFullYear()} Copyright NMMC Mumbai. All Rights Reserved.
                            </span>
                        </span>
                    </div>
                </div>



            </div>

        </>

    )
}